export default __webpack_public_path__ + "static/media/44.d80d88b3.jpeg";